// axios
import axios from 'axios'

// const baseURL = "http://127.0.0.1:8008";
const baseURL = 'https://api-finance.sigisystems.com'

axios.defaults.headers.common["Authorization"] = `Bearer ${localStorage.getItem(
  "accessToken"
)}`;

export default axios.create({
  baseURL,
  // You can add your headers here
});
